import { defineComponent as _defineComponent } from 'vue'
import ImageThumbnail from '@@/library/v4/components/ImageThumbnail.vue'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import { useSurfaceTrashedViewStore } from '@@/pinia/surface_trashed_view'
import { __ } from 'bits/intl'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceTrashed',
  setup(__props) {

const { isDarkMode } = storeToRefs(useDarkModeStore())
const { isCurrentUserWallBuilder, redirectUrl } = storeToRefs(useSurfaceTrashedViewStore())

const ORIGINAL_IMAGE_WIDTH = 1011
const ORIGINAL_IMAGE_HEIGHT = 623
const IMAGE_WIDTH = 275

const imageUrl = computed(() => {
  const BASE_IMAGE_URL = `https://padlet.net/trashed_padlet/v0/padlet_trashed_`
  const IMAGE_FILE_EXTENSION = '.webp'
  const imageColor = isDarkMode.value ? 'dark' : 'light'
  return BASE_IMAGE_URL + imageColor + IMAGE_FILE_EXTENSION
})

const description = computed(() => {
  return isCurrentUserWallBuilder.value
    ? __('You can restore it from the Trash section.')
    : __('It can only be restored by the user who moved it to Trash.')
})

const buttonText = computed(() => {
  return isCurrentUserWallBuilder.value ? __('Go to trash') : __('Go to dashboard')
})

return { __sfc: true,isDarkMode, isCurrentUserWallBuilder, redirectUrl, ORIGINAL_IMAGE_WIDTH, ORIGINAL_IMAGE_HEIGHT, IMAGE_WIDTH, imageUrl, description, buttonText, ImageThumbnail, __, OzContainedButton, OzContainedButtonColorScheme, OzContainedButtonSizePreset }
}

})